import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { Button, TextArea, Input } from 'semantic-ui-react';
import * as classes from './classes.module.scss';

export default class EditDescription extends PureComponent {
  static propTypes = {
    description: PropTypes.string,
    name: PropTypes.string,
    updateAttributes: PropTypes.func.isRequired,
    onCancel: PropTypes.func.isRequired
  };

  constructor(props) {
    super(props);
    const { name, description } = props;
    this.state = { newDescription: description, newName: name };
    this.textarea = React.createRef();
  }

  componentDidMount() {
    this.textarea.current.focus();
  }

  onChangeDescription = (event) => this.setState({ newDescription: event.target.value });

  onChangeName = (event) => this.setState({ newName: event.target.value });

  onSave = () => {
    const { newDescription, newName } = this.state;
    const { updateAttributes, onCancel } = this.props;
    updateAttributes({
      name: newName,
      description: newDescription
    });
    onCancel();
  };

  render() {
    const { newDescription, newName } = this.state;
    const { onCancel } = this.props;
    return (
      <div className={ classes.editDescription }>
        <strong>Wall Title:</strong>
        <Input
          value={ newName }
          onChange={ this.onChangeName }
        />
        <strong>Wall Description:</strong>
        <TextArea
          ref={ this.textarea }
          onChange={ this.onChangeDescription }
          value={ newDescription }
        />
        <div className={ classes.saveActions }>
          <Button onClick={ this.onSave }>SAVE</Button>
          <Button basic onClick={ onCancel }>CANCEL</Button>
        </div>
      </div>
    );
  }
}
